// ----------------------------------------------------------------------
// General
// ----------------------------------------------------------------------
import type { COMPONENT_BUILDANDBUY, COMPONENT_CAR_CONFIG } from "../../shared-logic/server/components";

export enum TradeInAemSearchType {
    LicensePlate = "licensePlate",
    VinNumber = "vinNumber",
}

export enum TradeInAemVersion {
    Standalone = "standalone",
    Integrated = "integrated",
    Hidden = "hidden",
}

// This should contain all the components where the Trade-in tool is used integrated inside OR
// Make sure to also update the relevant tracking see 'getIntegratedTrackingVariant'
export type TradeInAemIntegratedParentComponentType = typeof COMPONENT_BUILDANDBUY | typeof COMPONENT_CAR_CONFIG;

// ----------------------------------------------------------------------
// Navigation
// ----------------------------------------------------------------------

export enum TradeInAemNavStep {
    FindVehicle = "findVehicle",
    VehicleDetails = "vehicleDetails",
    VehicleValue = "vehicleValue",
    ModelSelect = "modelSelect",
    DealerFinder = "dealerFinder",
    ContactForm = "contactForm",
    Summary = "summary",
}

// ----------------------------------------------------------------------
// Vehicle Details
// ----------------------------------------------------------------------
export enum TradeInAemDetailFormItemType {
    Text = "text",
    Number = "number",
    Mileage = "mileage",
    Month = "month",
    Year = "year",
    Radio = "radio",
    Checkbox = "checkbox",
}

// ----------------------------------------------------------------------
// Model Select
// ----------------------------------------------------------------------
export enum TradeInAemModelSelectType {
    New = "new",
    Used = "used",
    Stock = "stock",
    None = "none",
}

// Currently, this list determines the order the model select blocks are shown in the ModelSelect step
export const tradeInAemModelSelectTypesList = [
    TradeInAemModelSelectType.New,
    TradeInAemModelSelectType.Stock,
    TradeInAemModelSelectType.Used,
    TradeInAemModelSelectType.None,
] as const;

// ----------------------------------------------------------------------
// Contact form
// ----------------------------------------------------------------------
export enum TradeInAemContactFormId {
    FirstName = "firstName",
    FirstLastName = "firstLastName",
    SecondLastName = "secondLastName",
    Address = "address",
    HouseNumber = "houseNumber",
    PostalCode = "postalCode",
    City = "city",
    Email = "email",
    Phone = "phone",
    PrivacyDisclaimers = "privacyDisclaimers",
}

export const tradeInAemContactTextItemIds = [
    TradeInAemContactFormId.FirstName,
    TradeInAemContactFormId.FirstLastName,
    TradeInAemContactFormId.SecondLastName,
    TradeInAemContactFormId.Address,
    TradeInAemContactFormId.HouseNumber,
    TradeInAemContactFormId.PostalCode,
    TradeInAemContactFormId.City,
    TradeInAemContactFormId.Email,
    TradeInAemContactFormId.Phone,
] as const;
export type TradeInAemContactTextIdType = (typeof tradeInAemContactTextItemIds)[number];

export const tradeInAemContactCheckboxIds = [TradeInAemContactFormId.PrivacyDisclaimers] as const;
export type TradeInAemContactCheckboxIdType = (typeof tradeInAemContactCheckboxIds)[number];

export type TradeInAemTextInputType = {
    label: string;
    required: boolean;
    value: string;
    description?: string;
    placeholder?: string; // Supported in layout but not required for now.
    validator?: {
        errorMessage: string;
        regex: string; // regex string without leading and trailing "/". If set, overwrites the default validation
    };
};
export type TradeInAemCheckboxType = {
    visualization: "checkbox" | "radiobutton";
    items: {
        value: string;
        label: string;
        url?: string; // If URL is used the label should contain a [link]{value}[/link] placeholder.
        required: boolean;
        selected: boolean;
        interacted?: boolean; // Interacted is used to avoid having 'false' selected by default when the visualisation is 'radiobutton'. This is also used for validation purposes.
    }[];
};
